import { useState, useCallback, useEffect } from "react";
import { AddRuleModal } from "@components/settings/Rules/AddRuleModal";
import { RulesDrawer } from "@components/settings/Rules/RulesDrawer";
import { getRuleTitle } from "@components/settings/Rules/utils";
import { useOverlays } from "contexts/OverlayContext";
import {
    RuleGroupType,
    TransactionRuleActionDefinition,
    TransactionRuleConditionDefinition,
} from "@common/types/transactionRule";

export interface NewTransactionRuleDefinition {
    groupId?: string;
    actions?: TransactionRuleActionDefinition[];
    conditions: TransactionRuleConditionDefinition[];
    order?: number;
    applyToExistingTransactions?: boolean;
    excludeMatchedTransfers?: boolean;
    requireExplicitConditions?: boolean;
    scopeEntityId?: number;
}

export const TransactionRuleCreationDrawer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"createRule">("createRule");
    const [displayGroupType, setDisplayGroupType] = useState<
        RuleGroupType | undefined
    >(undefined);

    const handleGroupTypeChange = useCallback((groupType: RuleGroupType) => {
        setDisplayGroupType(groupType);
    }, []);

    useEffect(() => {
        setDisplayGroupType(undefined);
    }, [overlayInfo?.data?.groupType]);

    if (!overlayInfo || !overlayInfo.data) {
        return null;
    }

    const headerGroupType = displayGroupType ?? overlayInfo.data.groupType;

    return (
        <RulesDrawer
            open={!overlayIsClosing}
            onClose={closeOverlay}
            headerText={getRuleTitle(headerGroupType)}
        >
            <AddRuleModal
                key={overlayInfo.data.groupType}
                close={closeOverlay}
                newRuleDefinition={overlayInfo.data.definition}
                source={overlayInfo.data.source}
                groupType={overlayInfo.data.groupType}
                onGroupTypeChange={handleGroupTypeChange}
            />
        </RulesDrawer>
    );
};
